import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recovery-report-grid',
  templateUrl: './recovery-report-grid.component.html',
  styleUrls: ['./recovery-report-grid.component.css']
})
export class RecoveryReportGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/recovery-reports/recovery-report-grid/recovery-report-grid.component.ts